import isObject from './isObject';

export default isObject;
